export const SHOW_BACK_BUTTON = 'App/SHOW_BACK_BUTTON'
export const TOGGLE_APP_VISIBILITY = 'App/TOGGLE_APP_VISIBILITY'
export const INITIALISE_APP = 'App/INITIALISE_APP'
export const CLOSE_APP = 'App/CLOSE_APP'
export const GET_WEBSTOCKET_ID = 'App/GET_WEBSTOCKET_ID'
export const FETCH_WEB_SOCKET_SESSION_ID = 'App/FETCH_WEB_SOCKET_SESSION_ID'
export const SAVE_WEB_SOCKET_SESSION_ID = 'App/SAVE_WEB_SOCKET_SESSION_ID'
export const SET_APP_LOCALE = 'App/SET_APP_LOCALE'
export const WEB_SOCKET_CONNECTION_ERROR = 'App/WEB_SOCKET_CONNECTION_ERROR'
export const CLOSE_MODAL_WARNING = 'App/CLOSE_MODAL_WARNING'
export const SET_MESSAGE = 'App/Stomp/SET_MESSAGE'
export const SET_RECEIVE_OBJECT = 'App/Stomp/SET_RECEIVE_OBJECT'
export const SET_SELECT_SKU = 'App/Stomp/SET_SELECT_SKU'
export const REMOVE_SELECT_SKU = 'App/Stomp/REMOVE_SELECT_SKU'
export const SAVE_STOMP_CLIENT = 'App/Stomp/SAVE_STOMP_CLIENT'
export const SET_IS_MOBILE = 'App/SET_IS_MOBILE'



// WEBPACK FOOTER //
// ./src/containers/App/constants.js